import { useState } from "react";
import { ArrowRight, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { post, errMsg } from "../../lib/api";

export const NewsletterForm = ({ source = "home", tone = "light", id = "newsletter", label, successMsg }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      const { data } = await post("/subscribe", { email, source });
      setState("done");
      setEmail("");
      toast.success(data?.already ? "You're already on the list." : successMsg ?? "You're on the list. We'll be in touch at launch.");
    } catch (err) {
      setState("idle");
      toast.error(errMsg(err));
    }
  };

  const dark = tone === "dark";
  return (
    <form onSubmit={submit} data-testid={`${id}-form`} className="w-full">
      <div className={`group flex items-center gap-2 rounded-full border-2 p-1.5 transition-colors duration-300 ${dark ? "border-dano-cream/40 focus-within:border-dano-cream" : "border-dano-ink focus-within:border-dano-red"}`}>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          aria-label="Email address"
          data-testid={`${id}-email-input`}
          className={`min-w-0 flex-1 bg-transparent px-4 py-3 text-base outline-none ${dark ? "text-dano-cream placeholder:text-dano-cream/60" : "text-dano-ink placeholder:text-dano-ink/50"}`}
        />
        <button
          type="submit"
          disabled={state === "loading"}
          data-testid={`${id}-submit-button`}
          className={`btn-press inline-flex shrink-0 items-center gap-2 rounded-full bg-dano-red py-3 font-cond text-base uppercase text-dano-cream hover:bg-dano-red-dark ${label ? "px-4 tracking-wide sm:px-5 sm:tracking-widest" : "px-5 tracking-widest"}`}
        >
          {state === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : state === "done" ? <Check className="h-4 w-4" /> : <ArrowRight className="h-4 w-4" />}
          <span className={label ? "" : "hidden sm:inline"}>{state === "done" ? (label ? "You're set" : "Joined") : label ?? "Join"}</span>
        </button>
      </div>
    </form>
  );
};
